import { useTheme } from '@/contexts/ThemeContext';

interface CaseReportAccidentSummaryProps {
    accident: any;
    isReadOnly?: boolean;
    officerLabel?: string;
    onAccidentChange?: (accident: any) => void;
}

export function CaseReportAccidentSummary({
    accident,
    isReadOnly = false,
    officerLabel = 'Officer',
    onAccidentChange,
}: CaseReportAccidentSummaryProps) {
    const { theme } = useTheme();

    const handleFieldChange = (field: string, value: string) => {
        if (onAccidentChange) {
            onAccidentChange({ ...accident, [field]: value });
        }
    };

    return (
        <div className={'case-report-accident-summary' + (theme ? ' ' + theme : '')}>
            <div className="header">
                <h1>Accident Summary</h1>
            </div>
            <div className="summary-body">
                <div className="form-group">
                    <label className="control-label"><b>Roadway Conditions:</b></label>
                    <textarea
                        className="form-control"
                        value={accident.roadwayConditions || ''}
                        disabled={isReadOnly}
                        rows={3}
                        onChange={(e) => handleFieldChange('roadwayConditions', e.target.value)}
                    />
                </div>
                <div className="form-group">
                    <label className="control-label"><b>Investigative Findings:</b></label>
                    <textarea
                        className="form-control"
                        value={accident.findings || ''}
                        disabled={isReadOnly}
                        rows={3}
                        onChange={(e) => handleFieldChange('findings', e.target.value)}
                    />
                </div>
                <div className="form-group">
                    <label className="control-label"><b>{officerLabel} Notes:</b></label>
                    <textarea
                        className="form-control"
                        value={accident.notes || ''}
                        disabled={isReadOnly}
                        rows={3}
                        onChange={(e) => handleFieldChange('notes', e.target.value)}
                    />
                </div>
            </div>
        </div>
    );
}

(window as any).CaseReportAccidentSummaryReact = CaseReportAccidentSummary;
